var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-warning white--text text-center font-weight-black",attrs:{"color":"warning"}},[_c('v-spacer'),_c('h2',{attrs:{"id":"warning-text"}},[_vm._v("Te encuentras en un ambiente de pruebas, no se procesará ninguna operación realizada aquí.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }